export default __webpack_public_path__ + "static/media/BeramoniumTurnBasedGameplay.18a33141.jpeg";